"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Inner = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  [theme.breakpoints.up('md')]: {
    borderLeft: '280px solid transparent'
  }
}));
const Inner = exports.Inner = (0, _mui.styled)('div')(({
  theme
}) => ({
  maxWidth: '100%',
  marginTop: theme.spacing(6),
  [theme.breakpoints.up('md')]: {
    maxWidth: '984px',
    marginLeft: theme.spacing(6),
    marginRight: theme.spacing(6)
  },
  [theme.breakpoints.up('xl')]: {
    marginLeft: 'auto',
    marginRight: 'auto'
  }
}));
